enum TypeUnit {
  DUS = 'Dus',
  GALON = 'Galon'
}

export default TypeUnit;
